export const formatPriceUSD = (price: string | number | undefined) => {
    const numPrice = Number(price);
    if (isNaN(numPrice)) {
        return '$0.00'; // or handle the error differently
    }
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(numPrice);
};